import { useContext } from 'react';

import { SelectOption } from './SelectOption';
import { AppContext } from '../../../main/context/Provider';
import { FlagSources, LocalStorage_keys } from '../../../main/constants';
import { localStorageService } from '../../../infrastructure/services';

export const SelectLanguage = () => {
    const { langResources, setLang, selectedFlag } = useContext(AppContext);

    const handlerChangeLenguage = (lang: string) => {
        localStorageService.create(LocalStorage_keys.LANG_KEY, lang);
        setLang(lang);
    };

    return (
        <div className='dropdown'>
            <button
                className='btn  dropdown-toggle btn-icon btn-topbar rounded-circle'
                type='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'
            >
                <img
                    src={selectedFlag}
                    style={{
                        width: '65%',
                    }}
                />
            </button>

            <ul
                className='dropdown-menu '
                style={{
                    background: 'white',
                }}
            >
                <SelectOption
                    flagRoute={FlagSources['en-US']}
                    handlerChangeLenguage={handlerChangeLenguage}
                    language={'en-US'}
                    languageName={langResources['languages']['english.name.label']}
                />

                <SelectOption
                    flagRoute={FlagSources['es-CO']}
                    handlerChangeLenguage={handlerChangeLenguage}
                    language={'es-CO'}
                    languageName={langResources['languages']['spanish.name.label']}
                />
            </ul>
        </div>
    );
};
